const GLOSSARY_METADATA_PATH: string = '/glossary-metadata';
const CREATE_NEW_DICTIONARY_VIEW_PATH = `${GLOSSARY_METADATA_PATH}/new`;

export const GLOSSARY_METADATA_PATHS = {
    LANDING_PAGE: GLOSSARY_METADATA_PATH,
    CREATE_NEW_GLOSSARY_METADATA_VIEW: `${CREATE_NEW_DICTIONARY_VIEW_PATH}`,
    CREATE_NEW_GLOSSARY_METADATA: `${CREATE_NEW_DICTIONARY_VIEW_PATH}/create-glossary`,
    CREATE_IMPORT_GLOSSARY_METADATA: `${CREATE_NEW_DICTIONARY_VIEW_PATH}/import-glossary`,
    UPDATE_GLOSSARY_METADATA: `${GLOSSARY_METADATA_PATH}/:id`,
};
